export default "__VITE_ASSET__DxAivW6G__"